<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('neighbors')"
      :columns="columns"
      :column_search="true"
      resource_url="/neighbor/datatables"
      :page_length="25"
      mode="grid"
      grid_class="is-col-min-11"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-upload"></i></span>
          <span>{{ $t("export for bi") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-download"></i></span>
          <span>{{ $t("import from bi") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
      <template #item="item">
        <div class="card">
          <div class="card-content">
            <!-- <div
              class="dropdown is-pulled-right is-right"
              :data-uuid="item.uuid"
              @mouseover="show_menu(item)"
              @mouseleave="hide_menu(item)"
            >
              <div class="dropdown-trigger">
                <div
                  class="tag"
                  aria-haspopup="true"
                  aria-controls="dropdown-menu"
                  :data-tooltip="$t('options')"
                >
                  <span class="icon is-small has-text-primary">
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
              <div class="dropdown-menu options-menu" role="menu">
                <div class="dropdown-content">
                  <a class="dropdown-item" @click="edit_member(item)">
                    <span class="icon has-text-warning">
                      <i class="fa fa-edit"></i>
                    </span>
                    <span>{{ $t("edit") }}</span>
                  </a>
                  <a class="dropdown-item" @click="buy_promotion(item)">
                    <span class="icon has-text-primary">
                      <i class="fa fa-battery"></i>
                    </span>
                    <span>{{ $t("buy promotion") }}</span>
                  </a>
                </div>
              </div>
            </div> -->
            <div class="media mb-0">
              <div class="media-left">
                <figure class="image is-48x48">
                  <v-lazy-image
                    v-if="item.settings.photo"
                    :src="`${api_host}/drive/static/${item.settings.photo.final_name}`"
                  />
                  <img
                    v-else
                    src="https://cdn-icons-png.flaticon.com/512/6833/6833573.png"
                  />
                </figure>
              </div>
              <div class="media-content">
                <div class="title is-5">
                  <span>{{ item.resident_name }}</span>
                  <small class="has-text-danger" v-if="!item.is_active">
                    ({{ $t("inactive") }})</small
                  >
                </div>
                <div class="subtitle is-6 mb-0" v-if="item.home_number">
                  <span class="icon">
                    <i class="fa fa-home"></i>
                  </span>
                  {{ item.home_number }}
                </div>
                <div class="subtitle is-6 mb-0" v-if="item.resident_email">
                  <span class="icon">
                    <i class="fa fa-at"></i>
                  </span>
                  {{ item.resident_email }}
                </div>
                <div
                  class="subtitle is-6 mb-0"
                  v-if="item.resident_phone_number"
                >
                  <span class="icon">
                    <i class="fa fa-phone"></i>
                  </span>
                  {{ item.resident_phone_number }}
                </div>
                <div
                  class="subtitle is-6 mb-0"
                  v-if="item.account && item.account.balance"
                  v-bind:class="{
                    'has-text-warning': Number(item.account.balance) < 0,
                    'has-text-success': Number(item.account.balance) >= 0,
                  }"
                >
                  <span class="icon">
                    <i class="fa fa-balance-scale"></i>
                  </span>
                  {{ format_currency(item.account.balance) }}
                </div>
                <!-- <pre class="subtitle is-6 mb-0">{{ item }}</pre> -->
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div
              href="#"
              class="card-footer-item"
              :data-tooltip="$t('edit')"
              @click="edit_neighbor(item)"
            >
              <span class="icon"> <i class="fa fa-edit"></i> </span>
            </div>
            <div
              href="#"
              class="card-footer-item"
              :data-tooltip="$t('account details')"
              @click="account_details(item)"
            >
              <span class="icon"> <i class="fa fa-list"></i> </span>
            </div>
            <div
              href="#"
              class="card-footer-item"
              :data-tooltip="$t('account movement')"
              @click="account_charge(item)"
            >
              <span class="icon"> <i class="fa fa-cube"></i> </span>
            </div>
            <div
              href="#"
              class="card-footer-item"
              :data-tooltip="$t('send qr code')"
              @click="send_qr(item)"
            >
              <span class="icon"> <i class="fa fa-qrcode"></i> </span>
            </div>
            <div
              href="#"
              class="card-footer-item"
              :data-tooltip="$t('delete')"
              @click="delete_neighbor(item)"
            >
              <span class="icon"> <i class="fa fa-trash"></i> </span>
            </div>
          </footer>
        </div>
      </template>
    </generic-table>
  </div>

  <neighbor-modal ref="neighbor_modal" @success="refresh" />
  <account-modal ref="account_modal" />
  <charge-modal ref="charge_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  put,
  success_message,
  error_message,
  format_currency,
  api_host,
  format_date,
} from "@/utils";
import NeighborModal from "./neighbor_modal/Index.vue";
import AccountModal from "./account_modal/Index.vue";
import ChargeModal from "./charge_modal/Index.vue";
import VLazyImage from "v-lazy-image";
import moment from "moment";

export default {
  name: "NeighborDatatable",
  components: {
    GenericTable,
    NeighborModal,
    AccountModal,
    VLazyImage,
    ChargeModal,
  },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    let v = this;
    return {
      api_host,
      columns: [
        {
          title: v.$t("member since"),
          name: "create_date",
          searchable: false,
          // width: "70%",
          data: (row) => {
            return format_date(row.create_date);
          },
        },
        {
          title: v.$t("member"),
          name: "name",
          searchable: true,
          // width: "70%",
          data: (row) => {
            let icon = "fa-user";
            if (row.member_type == "customer") icon = "fa-user-o";
            return `<span class="icon"><i class="fa ${icon}"></i></span>  ${row.name}`;
          },
        },
        {
          title: v.$t("birth date"),
          name: "birth_date",
          searchable: false,
          // width: "70%",
          data: (row) => {
            return format_date(row.birth_date);
          },
        },
        {
          title: v.$t("email"),
          name: "email",
          searchable: true,
          // width: "70%",
          data: (row) => {
            return row.email || "";
          },
        },
        {
          title: v.$t("phone number"),
          name: "phone_number",
          searchable: true,
          // width: "70%",
          data: (row) => {
            return row.phone_number || "";
          },
        },
        {
          title: v.$t("expire date"),
          name: "membership_expire_date",
          // searchable: true,
          // width: "70%",
          data: (row) => {
            return format_date(row.membership_expire_date);
          },
        },
        {
          title: v.$t("balance"),
          searchable: false,
          // width: "70%",
          data: (row) => {
            if (row.account && row.account.balance) {
              return format_currency(row.account.balance);
            } else return "";
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   // width: "70%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          //width: "30%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.edit_gym_member_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("buy promotion"),
                icon: "fa fa-battery",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.buy_promotion_modal.show_modal(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("register payment"),
                icon: "fa fa-credit-card",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.payment_modal.show_modal(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("account details"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.account_modal.show_modal(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("update membership expire date"),
                icon: "fa fa-clock-o",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.update_expire_membership_modal.show_modal(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete member?"),
                    v,
                    () => {
                      del("/gym_member", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_currency,
    moment,
    create() {
      let v = this;
      v.$refs.neighbor_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit_neighbor(element) {
      let v = this;
      v.$refs.neighbor_modal.edit_modal(element.uuid);
    },
    account_details(element) {
      let v = this;
      v.$refs.account_modal.show_modal(element);
    },
    delete_neighbor(element) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete neighbor?"),
        v,
        () => {
          del("/neighbor", { uuid: element.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    account_charge(element) {
      let v = this;
      v.$refs.charge_modal.show_modal(element);
    },
    send_qr(element) {
      let v = this;
      v.$root.loader(true);
      put("/neighbor/qr", { uuid: element.uuid })
        .then(() => {
          success_message(v.$t("qr code sent"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
